import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
//import { Button, Form, Alert } from "react-bootstrap";
//import Container from 'react-bootstrap/Container';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Box from '@mui/material/Box';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Redirect } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import PhoneInput from 'react-phone-number-input/input';
import MaskedInput from 'react-text-mask';
import * as actions from "../store/actions";
import * as actionTypes from "../store/actions/actionTypes";
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment/moment";
import Tariffs from './Tariffs';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,

    },
    input: {
        borderRadius: 4,
        position: 'relative',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 5px 10px 5px',
        margin: theme.spacing(1),
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

function AddClient(props){
    const classes = useStyles();
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    //const [macAddress, setMacAddress] = useState("00:1A:79:");
    const [macAddress, setMacAddress] = useState("");
    const [ministra, setMinistra] = useState(false);
    const [months, setMonths] = useState("3");
    const [server, setServer] = useState("0");
    const [description, setDescription] = useState("");
    const [phone, setPhone] = useState("");
    const [packageSelection, setPackageSelection] = useState(8); //tariff
    const [packageListLive, setPackageListLive] = useState("");
    const [packageListVod, setPackageListVod] = useState("");
    const [selectedPackages, setSelectedPackages] = useState({subs:[]});
    const [packagesList, setPackagesList] = useState(
        props.packages
    );

    useEffect(() => {
        console.log('inside addclient');
        props.onInitializeAddClient();
        //console.log('setting tariff to', packageSelection);
        props.onSetTariff(packageSelection);
        props.onGetPackageList(props.token, server);
    }, []);

    useEffect(()=>{
        if (props.packages && props.packages.length) {

            setPackagesList(props.packages);

            let filteredLiveData = props.packages.filter(item => {
                return item.type === "tv";
            });

            let filteredVodData = props.packages.filter(item => {
                return item.type === "video";
            });

            setPackageListLive(filteredLiveData);
            setPackageListVod(filteredVodData);

        }
    }, [props.packages]);

    useEffect(()=>{
        props.onGetPackageList(props.token, server);
    }, [server]);

    useEffect(() => {
        if (props.isErrorAddClient){
            var errorMessage = '' + props.isErrorAddClient;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        }
    }, [props.isErrorAddClient]);


    //const handleToggle = ({target}) =>
    //    setPackagesList(s => ({ ...s, [target.name]: !s[target.name]}));

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    const handleToggle = (event) => {
        //const target = event.target;
        //const value = target.type === 'checkbox' ? target.checked : target.value;
        //const name = target.name;
        //const key = target.key;
        //console.log('event name', event.target.name, ' value', event.target.value);
        const isChecked = event.target.checked;
        if (isChecked){
            setSelectedPackages({
                subs: [...selectedPackages.subs, event.target.value]
            });
        } else {
            const index = selectedPackages.subs.indexOf(event.target.value);
            selectedPackages.subs.splice(index,  1);
            setSelectedPackages({
                subs: selectedPackages.subs
            })
        }

        //setPackagesList({
        //    ...packagesList,
        //    [name]: {
        //        ...packagesList[name],
        //        checked: value
        //    }
        //})
    };

    //return(<Form.Check
    //    type="checkbox"
    //    onChange={handleToggle}
    //    key={key}
    //    id={key}
    //    name={key}
    //    label={packagesList[key].name}
    //    checked={packagesList[key].checked}
    ///>);

    useEffect(() => {
        //console.log('inside useEffect AddClient', props.tariff);
        setPackageSelection(props.tariff);
    }, [props.tariff]);

    let displayCustomPackages = null;

    if (packageSelection === 3){
        //console.log('inside change tariff to custom', props.tariff);
        displayCustomPackages = (
            <Box sx={{ display: 'flex' }}>
                <FormControl key="tv" sx={{ m: 3 }} component="fieldset" variant="standard">
                    <FormLabel component="legend">Live Packages</FormLabel>
                    {Object.keys(packagesList).map((key,value) => {
                        if (packagesList[key].type === "tv") {
                            return (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            type="checkbox"
                                            onChange={handleToggle}
                                            key={"tv_" + packagesList[key].id }
                                            value={packagesList[key].id}
                                            name="subs[]"
                                            label={packagesList[key].name}
                                            checked={(selectedPackages.subs.includes(packagesList[key].id))?true:false}
                                        />
                                    }
                                    label={packagesList[key].name}
                                />
                            );
                        }
                    })}
                </FormControl>
                <FormControl key="vod" sx={{ m: 3 }} component="fieldset" variant="standard">
                    <FormLabel component="legend">VOD Packages</FormLabel>
                    {Object.keys(packagesList).map((key,value) => {
                        if (packagesList[key].type === "video"){
                            return(
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            type="checkbox"
                                            onChange={handleToggle}
                                            key={"vod_" + packagesList[key].id}
                                            value={packagesList[key].id}
                                            name="subs[]"
                                            label={packagesList[key].name}
                                            checked={(selectedPackages.subs.includes(packagesList[key].id))?true:false}
                                        />
                                    }
                                    label={packagesList[key].name}
                                />
                            );
                        }

                    })}
                </FormControl>
            </Box>)
            
    }    
    

    
    function validateForm() {
        if (ministra){
            return login.length > 0 && login.length < 15 && password.length > 0 && password.length < 15 && description.length < 500 && phone.length < 15;
        } else {
            return macAddress.length === 17 && login.length > 0 && login.length < 15 && password.length > 0 && password.length < 15 && description.length < 500 && phone.length < 15;
        }

    }

    function handleSubmit(event) {
        console.log('Inside handle submit');
        event.preventDefault();

        const data = {
            login: login,
            password: password,
            stb_mac: macAddress,
            ministra: ministra,
            months: months,
            desc: description,
            phone: phone,
            package_selection: packageSelection,
            packages: selectedPackages.subs,
            server: server
        };

        if (packageSelection === 3 && (selectedPackages.subs.length === packagesList.length || selectedPackages.subs.length < 1)){
            var errorMessage = 'If you want to select all packages, then just select ALL PACKAGES from package selection.';
            if (selectedPackages.subs.length < 1){
                errorMessage = 'Please select at least ONE package or select a pre-defined package from the package selection.';
            }
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        } else {
            props.onAddClient(props.token, data);
        }

    }

    let addClientRedirect = null;
    if(props.isSuccessAddClient){
        props.onGetCredits(props.token);
        var successMessage = 'Added ' + props.isSuccessAddClient.name;
        props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});
        addClientRedirect = <Redirect to="/clients" />
    }


    let displayMacAddress = null;
    console.log('logging ministra: ', ministra);
    if (!ministra){
        displayMacAddress = (
                <FormControl>
                    <MaskedInput
                        mask={[/[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':', /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/]}
                        className={classes.input}
                        placeholder="Mac Address"
                        value={macAddress}
                        guide={true}
                        id="macAddress"
                        onChange={e => setMacAddress(e.target.value)}
                    />
                </FormControl>
        );
    }

    return (
        <div>
            {addClientRedirect}
            <Container>
                <Grid container spacing={2}>
                    <Grid item sm={12} xs={12}>
                        <Paper elevation={5}>
                            <Card>
                                <CardHeader
                                    title="Add Client"
                                    titleTypographyProps={{
                                        fontSize: 17,
                                        fontWeight: 'bold'
                                    }}
                                    subheaderTypographyProps={{
                                        fontSize: 14,
                                    }}
                                />
                                <Divider variant="middle" />
                                <CardContent>
                                    <form>
                                        <FormGroup row>
                                            <FormControl className={classes.formControl} fullWidth>
                                                <InputLabel id="select-server-label">Server</InputLabel>
                                                <Select
                                                    id="server"
                                                    labelId="Select server"
                                                    value={server}
                                                    onChange={e => setServer(e.target.value)}
                                                >
                                                    <MenuItem value={0} key="server_0">TITAN 4K</MenuItem>
                                                    <MenuItem value={1} key="server_1">COD 4K</MenuItem>
                                                    <MenuItem value={2} key="server_2">CROWN 4K</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </FormGroup>
                                        <FormGroup row>
                                            <FormControlLabel className={classes.formControl}
                                                            control={
                                                                <Switch
                                                                    checked={ministra}
                                                                    onChange={e => setMinistra(e.target.checked)}
                                                                    id="ministra"
                                                                    name="ministra"
                                                                />
                                                            }
                                                            label="Ministra"
                                            />
                                        </FormGroup> 
                                        {displayMacAddress}
                                        <FormControl className={classes.formControl}>
                                            <TextField
                                                autoFocus
                                                required
                                                error={login.length > 15}
                                                id="login"
                                                type="text"
                                                value={login}
                                                label="Enter login name"
                                                helperText={(login.length>15)?"Login name is too long":""}
                                                onChange={e => setLogin(e.target.value)}
                                                fullWidth
                                            />
                                        </FormControl>
                                        <FormControl className={classes.formControl}>
                                            <TextField
                                                required
                                                error={password.length > 15}
                                                id="password"
                                                value={password}
                                                label="Enter password"
                                                helperText={(password.length>15)?"Password is too long":""}
                                                onChange={e => setPassword(e.target.value)}
                                                type="text"
                                            />
                                        </FormControl> 
                                        <FormControl className={classes.formControl} fullWidth>
                                            <TextField
                                                id="description"
                                                error={description.length > 500}
                                                value={description}
                                                label="Description"
                                                helperText={(description.length>500)?"Description is too long":""}
                                                onChange={e => setDescription(e.target.value)}
                                                type="text"
                                                multiline
                                                maxRows={4}
                                                fullWidth
                                            />
                                        </FormControl>
                                        <FormGroup row>
                                            <FormControl>
                                                <MaskedInput
                                                    mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                                    className={classes.input}
                                                    placeholder="Enter a phone number"
                                                    value={phone}
                                                    guide={true}
                                                    id="phone"
                                                    onChange={e => setPhone(e.target.value)}
                                                />
                                            </FormControl>
                                        </FormGroup>
                                        <FormGroup row>
                                            <FormControl className={classes.formControl} fullWidth>
                                                <InputLabel id="select-months-label">Months</InputLabel>
                                                <Select
                                                    id="months"
                                                    labelId="Select subscription"
                                                    value={months}
                                                    onChange={e => setMonths(e.target.value)}
                                                >
                                                    <MenuItem value="0" key="month_0">Trial - 2 days</MenuItem>
                                                    <MenuItem value="1" key="month_1">1 Month</MenuItem>
                                                    <MenuItem value="2" key="month_2">2 Months</MenuItem>
                                                    <MenuItem value="3" key="month_3">3 Months</MenuItem>
                                                    <MenuItem value="4" key="month_4">4 Months</MenuItem>
                                                    <MenuItem value="5" key="month_5">5 Months</MenuItem>
                                                    <MenuItem value="6" key="month_6">6 Months</MenuItem>
                                                    <MenuItem value="7" key="month_7">7 Months</MenuItem>
                                                    <MenuItem value="8" key="month_8">8 Months</MenuItem>
                                                    <MenuItem value="9" key="month_9">9 Months</MenuItem>
                                                    <MenuItem value="10" key="month_10">10 Months</MenuItem>
                                                    <MenuItem value="11" key="month_11">11 Months</MenuItem>
                                                    <MenuItem value="12" key="month_12">12 Months</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </FormGroup>
                                        <FormGroup row>
                                            <FormControl className={classes.formControl} fullWidth>
                                                <InputLabel id="select-package-label">Package</InputLabel>
                                                <Tariffs s={server} />
                                            </FormControl>
                                        </FormGroup>
                                        <Box sx={{ display: 'flex' }}>
                                            {displayCustomPackages}
                                        </Box>                           
                                    </form>
                                </CardContent>
                                <CardActions>
                                        <Button
                                            block
                                            disabled={!validateForm() || props.isLoadingAddClient}
                                            type="submit"
                                            onClick={handleSubmit}
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            fullWidth
                                        >
                                            {props.isLoadingAddClient
                                                ? spinner
                                                : 'Add Client'}
                                        </Button>
                                </CardActions>
                            </Card>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onGetPackageList: (token, server) => dispatch(actions.packagesList(token, server)),
        onInitializeAddClient: () => dispatch(actions.initializeAddClient()),
        onAddClient: (token, data) => dispatch(actions.addClient(token, data)),
        onGetCredits: (token) => dispatch(actions.creditsUser(token)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message)),
        onSetTariff: (packageSelection) => dispatch(actions.setTariff(packageSelection))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        packages: state.packages.package_list,
        isLoading: state.packages.loading,
        isLoadingAddClient: state.addClient.loading,
        isErrorAddClient: state.addClient.error,
        isSuccessAddClient: state.addClient.client,
        tariff: state.tariff.tariff_plan
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(AddClient);